import axios from "axios";

// Create an API instance with base URL from environment variable or localhost:8000
export const api = axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL || "",
});

// Add request interceptor for logging and error prevention
api.interceptors.request.use(
    config => {
        console.log(`API Request to: ${config.baseURL}${config.url}`);
        
        // Prevent requests with null or undefined URLs
        if (!config.url) {
            console.warn('Preventing request with null or undefined URL');
            return new Promise(() => {});
        }
        
        return config;
    },
    error => {
        console.error('Request error:', error);
        return Promise.reject(error);
    }
);

// Add response interceptor for logging
api.interceptors.response.use(
    response => {
        console.log(`API Response status: ${response.status}`);
        return response;
    },
    error => {
        console.error('Response error:', error);
        return Promise.reject(error);
    }
);
